import { trainingApiClient } from "../../../../../http-common";


export const saveTrainerMaster = async (obj) => {
  return await trainingApiClient.post(`/masters/trainer/saveTrainer`, obj);
};
export const getAllTrainerList = async (obj) => {
  return await trainingApiClient.post(`/masters/trainer/getTrainerList`, obj);
};